import { equitiesOrderResumeData } from './types';

interface EquitiesTableTemplateProps {
  data: equitiesOrderResumeData[];
  assetCount: number;
  totalValue: string;
}

export const equitiesTableTemplate = ({
  assetCount,
  data,
  totalValue,
}: EquitiesTableTemplateProps) => {
  if (assetCount === 0) {
    return '';
  }

  return `
      <div class="product-card">
        <strong class="product-type-title">RENDA VARIÁVEL</strong>
        <div class="product-info">
          <span class="product-info-text">${assetCount} Ativo(s)</span>
          <span class="product-info-text">Total ${totalValue}</span>
        </div>
      </div>
      <div class="product-table">
        <div class="highlight-bar equities"></div>
        <div class="product-table-content">
          <table>
            <thead>
              <tr>
                <th style="width: 80px;">ativo</th>
                <th style="width: 40px;">operação</th>
                <th style="width: 60px;">ult.preço</th>
                <th style="width: 50px;">val. da ordem</th>
                <th style="width: 50px;">tipo de preço</th>
                <th style="width: 30px;">qtd</th>
                <th style="width: 50px;">valor por ativo</th>
                <th style="width: 40px;">valor est.</th>
              </tr>
            </thead>
            <tbody>
            ${data.map((item) => {
              return `<tr>
               <td>${item.productDisplay}</td>
               <td>${item.operation}</td>
               <td>
                <div class="product-last-price">
                  <div class="product-last-price-value">${item.lastPriceValueFormatted} ${item.lastPricePercentageFormatted}</div>
                  <span class="product-last-price-updated">${item.lastPriceDate}</span>
                </div>
                </td>
               <td>${item.maturityDate}</td>
               <td>${item.priceType}</td>
               <td>${item.quantity}</td>
               <td>${item.valueAppliedFormatted}</td>
               <td>${item.totalValueAppliedFormatted}</td>
             </tr>`;
            })}
            </tbody>
          </table>
        </div>
      </div>
      `;
};
